module.exports = __webpack_public_path__ + "static/cap-98a0358e77825f2c5012c6b19198c8e6.png";